module.exports = __webpack_public_path__ + "images/756c6cc787479b9578177c3d1fcd1eca-IMG_5432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_5432.jpg
// module id = ./src/assets/images/slides/living2/IMG_5432.jpg
// module chunks = 0